export default __webpack_public_path__ + "static/tag-do-5-light-5654cd010e170030a7c21fd59d59bc04.png";